jQuery(function ($) {
  const extensions = [
    'pdf',
    'csv',
    'doc',
    'ppt',
    'rtf',
    'xls',
    'zip',
  ]

  $('a').click(function (event) {
    extensions.forEach(function (extension) {
      if (event.currentTarget.href.indexOf('.'+extension) !== -1) {
        // Create a promise which either returns once ga has fired an event, or
        // after 500ms, whichever comes first
        if (typeof ga !== 'undefined') {
          var p = new Promise(function (resolve, reject) {
            setTimeout(function () {
              reject(new Error('ga hitCallback failed'))
            }, 500);
            ga('send', 'event', 'Downloads', extension.toUpperCase(), event.currentTarget.href, {
              'transport': 'beacon',
              'hitCallback': resolve,
            })
          })

          // Execute the promise
          p.finally(function () {
            // do nothing
          })
        }
      }
    })
  })
})
